import { createFileRoute, Link } from '@tanstack/react-router';
import { useThread } from '@/data/messaging';
import { ThreadView } from '@/components/messaging/ThreadView';

export const Route = createFileRoute('/admin/messages/$threadId')({
  component: AdminThread,
});

function AdminThread() {
  const { threadId } = Route.useParams();
  const thread = useThread(threadId);

  return (
    <div className="flex h-[calc(100dvh-10rem)] flex-col space-y-6">
      <header>
        <Link
          to="/admin/messages"
          className="text-[var(--color-ink-muted)] text-[var(--text-sm)] hover:text-[var(--color-ink)]"
        >
          ← Inbox
        </Link>
        <h1 className="mt-2">{thread.data?.subject ?? 'Conversation'}</h1>
        {thread.data && (
          <p className="mt-1 text-[var(--color-ink-muted)] text-[var(--text-sm)]">
            Family <span className="font-mono">{thread.data.family_id.slice(0, 8)}…</span> · started{' '}
            {new Date(thread.data.created_at).toLocaleDateString()}
          </p>
        )}
      </header>

      <div className="flex-1 overflow-hidden">
        <ThreadView threadId={threadId} viewerRole="admin" />
      </div>
    </div>
  );
}
